<template>
    <div class="content-wrapper app-listing-page">
        <div class="row align-items-start mb-4">
            <div class="col-lg-8">
                <app-breadcrumb :page-title="$t('users')" :icon="'grid'" />
                <p class="app-listing-page__intro text-muted mb-0">
                    {{ $t('users_page_intro') }}
                </p>
            </div>
            <div class="col-lg-4 mt-3 mt-lg-0">
                <div class="app-listing-page__top-actions">
                    <button
                        type="button"
                        class="btn btn-primary btn-with-shadow"
                        data-toggle="modal"
                        @click="openAddEditModal">
                        {{ `${this.$t('add')}` }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="refreshTable"
                    >
                        {{ this.$t('refresh') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="card card-with-shadow border-0 mb-4">
            <div class="card-body app-listing-page__table-card-body">
                <app-table :id="tableId" :options="options" @action="getListAction" />
            </div>
        </div>

        <user-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="user-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppUsers",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'users-table',
            rowData: {},
            options: {
                name: 'AppUsers',
                url: actions.USER,
                showHeader: true,
                tableShadow: false,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('first_name'),
                        type: 'text',
                        key: 'first_name',
                    },
                    {
                        title: this.$t('last_name'),
                        type: 'text',
                        key: 'last_name'
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: (value) => {
                            if (value) {
                                let ClassName = 'danger';

                                if (value.name === 'status_active') ClassName = `success`;
                                else if (value.name === 'status_invited') ClassName = `warning`;

                                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(value.translated_name)}</span>`;
                            }
                        }
                    },
                    {
                        title: this.$t('email'),
                        type: 'text',
                        key: 'email'
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'app-add-modal',
                        modalId: 'demo-add-edit-Modal',

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                    }
                ],
                filters: [
                    {
                        title: this.$t("status"),
                        type: "checkbox",
                        key: "status",
                        option: [],
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        refreshTable() {
            this.$hub.$emit('reload-' + this.tableId);
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.USER}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.USER}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#user-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
